<template>
  <div class="sns-icon-layout">
    <ul class="editor-design">
      <li>
        レイアウト
      </li>
      <li class="flex-box">
        <!-- 表示タイプ -->
        <select-box
          :target="'data-display-sns'"
          :value="displaySns"
          @updateAttrs="updateAttrs($event)"
        />
        <!-- アイコンスタイル -->
        <div>
        <span class="common-label">アイコンスタイル</span>
          <v-select
            label="text"
            :options="initSrcTypeOptions"
            :value="displaySrcType"
            :clearable="false"
            @input="updateSrcType($event)"
          >
            <template v-slot:option="option" >
              {{ option.value }}
              <img v-if="partsContainerType === 'FollowButton'" :src="constants.instagramIcon.url[option.text]" />
              <img v-else :src="constants.lineIcon.url['color']" />
              <img :src="constants.facebookIcon.url[option.text]" />
              <img v-if="option.text === 'black'" :src="constants.xIcon.url['color']" />
              <img v-else :src="constants.xIcon.url[option.text]" />
            </template>
          </v-select>
        </div>
      </li>
      <li class="flex-box">
        <!-- レイアウト選択 -->
        <div class="common-buttons-box">
          <button
            v-for="layout in layouts"
            :key="layout.value"
            @click="changePartLayout(layout.value)"
            :class="{'active': partLayoutType === layout.value}"
          >
            <i :class="['fas', layout.text]"></i>
          </button>
        </div>
        <div class="common-buttons-box" v-if="displaySns === 'IconText'">
          <button
            v-for="layout in layoutTextPlacements"
            :key="layout"
            @click="changeTextPlacementLayout(layout)"
            :class="{'active': textPlacementType === layout}"
            class="icon-text-button"
          >
            <img class="icon-text-img" :src="iconTextLayoutImg(layout, textPlacementType === layout)" />
          </button>
        </div>
        <!-- 表示位置 -->
        <select-button
          :target="'align'"
          :value="align"
          @updateStyles="updateStyles($event)"
        />
        <!-- アイコンサイズ -->
        <div class="common-buttons-box layout inline-block-display">
          <button
            v-for="size in iconSizes"
            :key="size.value"
            @click="changeIconSize(size.value)"
            :class="{'active': iconSize === size.value}"
          >
            <i :class="['fas', size.text]"></i>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import constants from '@/constants'
import vSelect from 'vue-select'
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'

export default {
  props: [
    'displaySns',
    'sectionId',
    'partsContainerId',
    'partId',
    'align',
    'layoutType',
    'iconSize',
    'srcType',
    'firstSnsName',
    'partsContainerType',
  ],
  components: {
    vSelect,
    SelectBox,
    SelectButton,
  },
  data () {
    return {
      constants: constants,
      layouts: [
        { text: 'fa-ellipsis-h', value: 'horizontal' },
        { text: 'fa-ellipsis-v', value: 'vertical' },
      ],
      layoutTextPlacements: [ 'horizontal', 'vertical' ],
      partLayoutType: '',
      textPlacementType: '',
      iconSizes: [
        { text: 'fa-circle fa-lg', value: '48px' },
        { text: 'fa-circle fa-xs', value: '32px' },
      ],
      initSrcTypeOptions: [
        { text: 'color', value: 'カラー' },
        { text: 'black', value: 'ブラック' },
        { text: 'gray', value: 'グレー' },
        { text: 'white', value: 'ホワイト' },
      ],
      displaySrcType: ''
    }
  },
  created () {
    // ページ読み込み時にセレクトボックスに表示するアイコンタイプを取得
    for (let option of this.initSrcTypeOptions) {
      if (option.text === this.srcType) {
        this.displaySrcType = option.value
        break
      }
    }
    this.separatedLayoutTypeToOption()
  },
  computed: {
    iconTextLayoutImg: function () {
      return function (value, isActive) {
        let src = ''
        if (value === 'horizontal') {
          src = isActive ? constants.snsLayoutIconTextImg.horizontal.white : constants.snsLayoutIconTextImg.horizontal.black
        } else {
          src = isActive ? constants.snsLayoutIconTextImg.vertical.white : constants.snsLayoutIconTextImg.vertical.black
        }
        return src
      }
    }
  },
  methods: {
    separatedLayoutTypeToOption () {
      this.partLayoutType = this.layoutType.replace(/2row/g, '')
      this.textPlacementType = this.layoutType.match(/2row/) ? 'vertical' : 'horizontal'
    },
    getLayoutType () {
      let type = ''
      if (this.displaySns === 'IconText') {
        if (this.partLayoutType === 'horizontal' && this.textPlacementType === 'horizontal') {
          type = 'horizontal'
        } else if (this.partLayoutType === 'vertical' && this.textPlacementType === 'horizontal') {
          type = 'vertical'
        } else if (this.partLayoutType === 'horizontal' && this.textPlacementType === 'vertical') {
          type = 'horizontal2row'
        } else {
          type = 'vertical2row'
        }
      } else {
        if (this.partLayoutType === 'horizontal') {
          type = 'horizontal'
        } else {
          type = 'vertical'
        }
      }
      return type
    },
    updateSrcType (valueObj) {
      const iconName = this.firstSnsName.toLowerCase() + 'Icon'
      this.displaySrcType = valueObj.value
      this.$store.commit('updateSnsIconSrcType', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        newSnsIcon: JSON.parse(JSON.stringify(constants[iconName])),
        newSrcType: valueObj.text,
      })
    },
    updateAttrs (attrs) {
      // 表示形式を変える場合はテキスト位置を水平にする
      this.textPlacementType = 'horizontal'
      this.$store.commit('updatePartAttrs', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        attrs,
      })
    },
    updateStyles (styles) {
      this.$store.commit('updatePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    },
    changePartLayout (newLayout) {
      if (this.partLayoutType === newLayout) return
      this.partLayoutType = newLayout
      this.$store.commit('updateSnsIconLayout', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        newLayout: this.getLayoutType(),
      })
    },
    changeTextPlacementLayout (newLayout) {
      if (this.textPlacementType === newLayout) return
      this.textPlacementType = newLayout
      this.$store.commit('updateSnsIconLayout', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        newLayout: this.getLayoutType(),
      })
    },
    changeIconSize (newSize) {
      if (this.iconSize === newSize) return
      const attrs = [{ prop: 'width', value: newSize }, { prop: 'height', value: newSize }]
      this.$store.commit('updatePartAttrs', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        attrs,
      })
    },
  },
}
</script>

<style lang="scss">
.sns-icon-layout {
  .editor-design {
    .flex-box {
      align-items: flex-start;
      margin-bottom: 0;
      padding-bottom: 10px;
    }
  }
  .inline-block-display {
    display: inline-block;
  }
  .vs--single {
    width: 180px;
    background-color: #fff;
  }
  .vs__dropdown-toggle {
    height: 38px !important;
  }
  .v-select {
    font-size: 14px;
    border-radius: 4px;
    top: 0;
    margin: 0 10px 0 0;
    .vs__dropdown-menu {
      background: #767676 !important;
    }
    .vs__selected {
      color: rgba(35, 24, 21, 0.75);
    }
    .vs__dropdown-option {
      background: #767676 !important;
      color: white;
    }
    img {
      float: right;
      width: 25px;
      height: 25px;
    }
    .vs__clear,
    .vs__open-indicator {
      fill: #484848;
    }
  }
  .icon-text-img {
    width: 20px;
  }
}
</style>
